import { render, staticRenderFns } from "./ChuangR.vue?vue&type=template&id=3ee8ce90&scoped=true&"
import script from "./ChuangR.vue?vue&type=script&lang=js&"
export * from "./ChuangR.vue?vue&type=script&lang=js&"
import style0 from "./ChuangR.vue?vue&type=style&index=0&id=3ee8ce90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee8ce90",
  null
  
)

export default component.exports